import { IconNames } from '@blueprintjs/icons';
import { CompanionListItemFragment, Intent, Tag, UserStatus } from '../../generated/graphql';

export const dummyTags: Tag[] = [
  {
    id: '1',
    name: 'Rollstuhl',
    icon: IconNames.SHOPPING_CART,
    intent: Intent.None,
    description: null,
    created_at: '2019-01-04 12:00:00',
    updated_at: '2019-01-04 12:00:00',
  },
  {
    id: '2',
    name: 'Rollstuhl',
    icon: IconNames.SHOPPING_CART,
    intent: Intent.None,
    description: null,
    created_at: '2019-01-04 12:00:00',
    updated_at: '2019-01-04 12:00:00',
  },
];

export const dummyCompanions: CompanionListItemFragment[] = [
  {
    id: '1',
    can_blind: true,
    can_drive: false,
    can_wheelchair: true,
    can_wheeled_walker: false,
    user: {
      id: '1',
      status: UserStatus.Active,
      display_name: 'Benjamin Wulff',
      email: 'benjamin.wulff@me.com',
      phone: '0000 0000 0000',
    },
    organisation: {
      id: '1',
      name: 'Keine Organisation',
    },
    tags: [],
  },
  {
    id: '2',
    can_blind: false,
    can_drive: false,
    can_wheelchair: false,
    can_wheeled_walker: false,
    user: {
      id: '2',
      status: UserStatus.Active,
      display_name: 'Mario Speedwagon',
      email: 'mario.speedwagon@googlemail.com',
      phone: '0000 0000 00',
    },
    organisation: null,
    tags: [dummyTags[0], dummyTags[1]],
  },
  {
    id: '3',
    can_blind: true,
    can_drive: false,
    can_wheelchair: true,
    can_wheeled_walker: false,
    user: {
      id: '3',
      status: UserStatus.Active,
      display_name: 'Anna Sthesia',
      email: 'anna.sthesia@gmail.de',
      phone: '000 0000 00',
    },
    organisation: {
      id: '3',
      name: 'Organisation mit sehr langem Namen',
    },
    tags: [],
  },
  {
    id: '4',
    can_blind: true,
    can_drive: false,
    can_wheelchair: true,
    can_wheeled_walker: false,
    user: {
      id: '4',
      status: UserStatus.Active,
      display_name: 'Forcewind Forcewind',
      email: null,
      phone: '0000 0000 00',
    },
    organisation: {
      id: '4',
      name: 'Kurzorganisation',
    },
    tags: [dummyTags[0]],
  },
];
